// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { BrowserClient } from '@sentry/browser';
import { sentryDsn as dsn, CLUSTER, RIG_DEPLOYMENT_TYPE } from './constants';

const serviceHub = new Sentry.Hub();

const config = {
  dsn,
  tracesSampleRate: 0,
  integrations(integrations) {
    return integrations.filter(
      integration => integration.name !== 'Breadcrumbs'
    );
  },
  initialScope: {
    tags: {"rig_deployment_type": RIG_DEPLOYMENT_TYPE},
  },
  environment: CLUSTER,
  allowUrls: [/^https?:\/\/www\.bfisland\.com\/static-assets/],
  sampleRate: 1,
  attachStacktrace: true,
  beforeSend(event) {
    if (event.level === 'fatal') {
      return event;
    }
    return Math.random() < 0.5 ? null : event;
  }
};

// Bind the client to service specific hub
serviceHub.bindClient(new BrowserClient(config));

export { serviceHub };
export const captureException = (error, options) => {
  // Set the level in the scope before capturing
  serviceHub.withScope(scope => {
    if (options?.level === 'fatal') {
      scope.setLevel('fatal');
    }
    if (options?.tags) {
      scope.setTags(options.tags);
    }
    if (options?.extra) {
      scope.setExtras(options.extra);
    }
    serviceHub.captureException(error, options);
  });
}
